import { FC, useMemo } from "react";
import { v4 as uuid } from "uuid";
import { CommonIconProps } from "../Icon/types";

const Spark: FC<
  CommonIconProps & {
    styled?: boolean;
    fillSecondary?: CommonIconProps["fill"];
  }
> = ({
  styled,
  fill = `var(--icon-fill-color, ${styled ? "hsl(326, 100%, 80%)" : "var(--color-primary)"})`,
  fillSecondary = `var(--icon-fill-secondary-color, ${styled ? "hsl(273, 57%, 16%)" : fill})`,
  stroke = "var(--icon-stroke-color, none)"
}) => {
  const id = useMemo(() => uuid(), []);
  return (
    <svg
      className="icon-spark"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7979 23C11.6738 23 11.569 22.9092 11.5477 22.7874C11.2062 20.8646 10.6223 19.4636 9.64944 18.4945L9.64459 18.4897C8.67269 17.5215 7.26529 16.9389 5.33509 16.5987C5.21287 16.5775 5.1217 16.4731 5.1217 16.3495L5.12169 15.3736C5.12169 15.2499 5.21287 15.1455 5.33508 15.1243C7.26528 14.7842 8.6717 14.2025 9.64456 13.2334L9.64941 13.2286C10.6213 12.2604 11.2062 10.8585 11.5476 8.93568C11.5689 8.81393 11.6737 8.72311 11.7978 8.72311L12.7775 8.72312C12.9016 8.72312 13.0064 8.81394 13.0277 8.93569C13.3692 10.8585 13.9531 12.2595 14.925 13.2277L14.9298 13.2325C15.9017 14.2006 17.3091 14.7833 19.2393 15.1234C19.3615 15.1447 19.4527 15.249 19.4527 15.3727L19.4527 16.3486C19.4527 16.4723 19.3615 16.5766 19.2393 16.5979C17.3091 16.938 15.9027 17.5196 14.9299 18.4887L14.925 18.4936C13.9531 19.4617 13.3682 20.8637 13.0268 22.7865C13.0055 22.9082 12.9007 22.999 12.7766 22.999L11.7969 22.999L11.7979 23Z"
        fill={`url(#paint0${id})`}
      />
      <path
        d="M21.5 9.74289C21.5 11.4325 20.1251 12.8022 18.4291 12.8022C16.733 12.8022 15.3581 11.4325 15.3581 9.74289C15.3581 8.05326 16.733 6.68355 18.4291 6.68355C20.1251 6.68355 21.5 8.05326 21.5 9.74289Z"
        fill={`url(#paint1${id})`}
      />
      <path
        d="M7.55238 11.5043C7.45843 11.5043 7.37916 11.4374 7.36301 11.3479C7.10455 9.93316 6.66263 8.90233 5.92639 8.18925L5.92272 8.18569C5.18722 7.47332 4.12218 7.04459 2.66154 6.79426C2.56905 6.77861 2.50005 6.70183 2.50005 6.61084L2.5 5.89283C2.49999 5.80183 2.56898 5.72506 2.66147 5.70942C4.12208 5.45928 5.18633 5.03138 5.92247 4.31839L5.92614 4.31483C6.66155 3.60256 7.10408 2.57107 7.36235 1.15639C7.37849 1.06681 7.45776 0.999994 7.55171 1L8.29303 1.00005C8.38698 1.00005 8.46626 1.06688 8.48241 1.15645C8.74086 2.57116 9.18279 3.602 9.91829 4.31436L9.92196 4.31792C10.6575 5.03029 11.7225 5.45903 13.1831 5.70935C13.2756 5.725 13.3446 5.80178 13.3446 5.89277L13.3447 6.61078C13.3447 6.70178 13.2757 6.77855 13.1832 6.79419C11.7226 7.04434 10.6583 7.47223 9.92221 8.18522L9.91854 8.18878C9.18313 8.90106 8.74061 9.93255 8.48233 11.3472C8.46619 11.4368 8.38692 11.5036 8.29297 11.5036L7.55238 11.5043Z"
        fill={`url(#paint2${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0${id}`}
          x1="4.4"
          y1="2.1"
          x2="22.8533"
          y2="19.0804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="1" stopColor={fillSecondary} />
        </linearGradient>
        <linearGradient
          id={`paint1${id}`}
          x1="4.4"
          y1="2.1"
          x2="22.8533"
          y2="19.0804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="1" stopColor={fillSecondary} />
        </linearGradient>
        <linearGradient
          id={`paint2${id}`}
          x1="4.4"
          y1="2.1"
          x2="22.8533"
          y2="19.0804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="1" stopColor={fillSecondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Spark;
